export const NumberType = Object.freeze({
  DEFAULT: "DEFAULT",
  GLOBAL: "GLOBAL",
  ORGANIZATION: "ORGANIZATION",
  USER: "USER",
});
